module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAPCAYAAAALWoRrAAAAAXNSR0IArs4c6QAAAPJJREFUOBG1kT8KwjAUh5u04p/dQXB1EgfP4Ork4OIxHARdXLyEmyA4eA4F3XoC71DoILaNX4bSYltpag2El/ze+315SSzrD0MopdpwOzWwPSHES3OcKIpcwIMaoGcYc82RADecoH6B4vdt297FDOk4jj5hGwumUTckpVwQ3Yw3DMNTEATKdOJbZWCxwDO0AN5MoAAPsT8dRXoDuMfH3Yn9tF6wvvCOE679LMgnMsAxHfjfOib/oK6buEqsMMwwRnlgdI/8qAQmW4J5/QlFCwFOs9UGCoxjGsx+aWDPL6WrJtCrBgPc51dVUAE3mMMK1notb836ICWMiIDAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/down_white.png
// module id = 229
// module chunks = 46